import * as types from "../constants/ActionTypes";

const initialState = false;

const isReconnectModalActive = (state = initialState, action) => {
  switch (action.type) {
    case types.CHANGE_RECONNECT_MODAL_STATUS:
      return action.status;
    default:
      return state;
  }
};

export default isReconnectModalActive;
